import { LitElement, html, unsafeCSS } from 'lit';
import './react-init.js';
import './index.css';
import { initializeApp } from './main.jsx';
import { fetchStaticData } from './api/staticData/HandleStaticData.api.js';
import { FONT, COLORS } from './theme/theme';

function resolveAnalyticsHandler(element) {
  return typeof element.analyticsCallback === 'function'
    ? element.analyticsCallback
    : typeof window.analyticsCallback === 'function'
      ? window.analyticsCallback
      : typeof window.dataLayer !== 'undefined'
        ? (data) => window.dataLayer.push(data)
        : null;
}



class AppointmentWidget extends LitElement {
  static instance = null;

  static getInstance() {
    if (!AppointmentWidget.instance) {
      AppointmentWidget.instance = new AppointmentWidget();
    }
    return AppointmentWidget.instance;
  }

  static properties = {
    uid: { type: String, reflect: true },
    embedded: { type: Boolean, reflect: true },
    logged_in_user_email: { type: String, reflect: true },
    logged_in_user_id: { type: String, reflect: true },
    host_application_name: { type: String, reflect: true },
    analyticsCallback: { type: Function },
  };

  static styles = unsafeCSS`
    :host {
      all: initial;
      display: block;
      width: 100%;
      height: 100%;
      font-family: "Inter Variable";
      font-size: 16px;
      font-weight: 400;
      line-height:1.5;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      -webkit-text-size-adjust: 100%;
      text-size-adjust: 100%;
      color: ${COLORS.BLACK};
    }
    :host b {
      font-weight: ${FONT.WEIGHT.BOLD} !important;
    }
    #react-root {
      all: initial;
      /* display: block; */
      width: 100%;
      height: 100%;
      font-family: "Inter Variable";
      font-size: 16px;
      font-weight: 400;
      line-height: 1.5;
      color: ${COLORS.BLACK};
      text-align: start;
      letter-spacing: normal;
      word-spacing: normal;
      text-transform: none;
      direction: ltr;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      -webkit-text-size-adjust: 100%;
      text-size-adjust: 100%;
    }
    #react-root *,
    #react-root *::before,
    #react-root *::after {
      box-sizing: border-box;
    }
  `;

  constructor() {
    super();
    this._root = null;
    this.isInitialized = false;
    this.uid = '';
    this.embedded = false;
    this.logged_in_user_email = null;
    this.logged_in_user_id = null;
    this.host_application_name=null;
    this.analyticsCallback = null;
  }

  firstUpdated(changedProperties) {
    const style = document.createElement('style');
    style.textContent = `
    input[name="file"] {
        display: none !important;
    }
    `;

    // Create a container for React
    const container = document.createElement('div');
    container.id = 'react-root';
    this.shadowRoot.appendChild(style);
    this.shadowRoot.appendChild(container);
    this._root = container;
  }

  updated(changedProperties) {
    if (!this.isInitialized && this._root) {
      this.isInitialized = true;

      const analyticsHandler = resolveAnalyticsHandler(this);

      const runApp = (initialStaticData) => {
        initializeApp(
          this._root,
          this.uid,
          this.embedded,
          this.logged_in_user_email,
          this.logged_in_user_id,
          false,
          null,
          this.host_application_name,
          analyticsHandler,
          initialStaticData
        );
      };

      if (this.uid) {
        fetchStaticData({
          webbot_uid: this.uid,
          region_id: null,
          auth0_user_id: this.logged_in_user_id,
        })
          .then((data) => runApp(data != null ? data : null))
          .catch(() => runApp(null));
      } else {
        runApp(undefined);
      }
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    // Clean up when widget is removed
    if (this._root) {
      const root = this._root;
      if (root._reactRootContainer) {
        root._reactRootContainer.unmount();
      }
    }
  }

  render() {
    return html`
      <div id="react-root"></div>
    `;
  }
}

class EnterpriseAppointmentWidget extends AppointmentWidget {
  static instance = null;

  static getInstance() {
    if (!EnterpriseAppointmentWidget.instance) {
      EnterpriseAppointmentWidget.instance = new EnterpriseAppointmentWidget();
    }
    return EnterpriseAppointmentWidget.instance;
  }

  static properties = {
    ...AppointmentWidget.properties,
    region_id: { type: String, reflect: true }
  };


  constructor() {
    super();
    this.region_id = null;
  }

  updated(changedProperties) {
    if (changedProperties.has('region_id')) {
      if (this.region_id === '') {
        this.region_id = null;
      }
      if (!this._root) return;

      const analyticsHandler = resolveAnalyticsHandler(this);

      const runApp = (initialStaticData) => {
        initializeApp(
          this._root,
          this.uid,
          this.embedded,
          this.logged_in_user_email,
          this.logged_in_user_id,
          true,
          this.region_id,
          this.host_application_name,
          analyticsHandler,
          initialStaticData
        );
      };

      if (this.uid) {
        fetchStaticData({
          webbot_uid: this.uid,
          region_id: this.region_id,
          auth0_user_id: this.logged_in_user_id,
        })
          .then((data) => runApp(data != null ? data : null))
          .catch(() => runApp(null));
      } else {
        runApp(undefined);
      }
    }
  }

  render() {
    return html`
      <div id="react-root"></div>
      <div id="region_id" style="display: none;">${this.region_id}</div>
    `;
  }
}

// Register the web components
customElements.define('appointment-widget', AppointmentWidget);
customElements.define('enterprise-appointment-widget', EnterpriseAppointmentWidget);
